import { useCallback } from 'react';

import { useWorkflowForm } from '../../../../../contexts/CampaignWorkflowFormContext';
import { useGetSendEmailSelector } from './useGetSendEmailSelector';
import { SendEmailRequiredConfigRule } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Workflow/Rules';

export const useGetHasMissingFieldsSelector = () => {
  const { state } = useWorkflowForm();
  const getSendEmail = useGetSendEmailSelector();

  return useCallback(
    (id: string): boolean =>
      SendEmailRequiredConfigRule(getSendEmail(id)).result === 'fail' && !state.focused[id] && !!state.touched[id],
    [getSendEmail, state.focused, state.touched],
  );
};
